import { render, staticRenderFns } from "./jieMeiTao.vue?vue&type=template&id=224d0cd4&scoped=true"
import script from "./jieMeiTao.vue?vue&type=script&lang=js"
export * from "./jieMeiTao.vue?vue&type=script&lang=js"
import style0 from "./jieMeiTao.vue?vue&type=style&index=0&id=224d0cd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d0cd4",
  null
  
)

export default component.exports